import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import { ContactSection } from './components/FeaturesSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />
        <MediaSection />
        <RankingSection />
        <CardsSection />
        <FaqSection />
        <CarouselSection />
        <FeaturesSection />
        <ContactSection />
        <TopicsSection />
        <AboutSection />
        <AppSection />
        <IndexSection />
        <CommentsSection />
        <UpdatesSection />
      </main>

      <Footer />
    </div>
  );
}